import { createFileRoute } from "@tanstack/react-router";

import { PublicWorkflowJoinPage } from "src/pages/PublicWorkflowJoinPage";

export const Route = createFileRoute("/_hybrid/workflow/$workflowId/join")({
  component: PublicWorkflowJoinPage,
  ssr: true,
  staticData: {
    getLayoutSettings() {
      return {
        useAuthLayout: false,
      };
    },
  },
});
